export const WHEEL_HASH_DETAIL_FETCH_START = 'WHEEL_HASH_DETAIL_FETCH_START';
export const WHEEL_HASH_DETAIL_FETCH_SUCCESS = 'WHEEL_HASH_DETAIL_FETCH_SUCCESS';
export const WHEEL_HASH_DETAIL_FETCH_FAIL = 'WHEEL_HASH_DETAIL_FETCH_FAIL';
export const WHEEL_HASH_DETAIL_FETCH_RESET = 'WHEEL_HASH_DETAIL_FETCH_RESET';